import { Injectable, NgZone } from "@angular/core";

/**
 * Monitorea la actividad del usuario en la pestaña.
 * No cierra sesión: solo expone cuánto tiempo ha pasado desde la última
 * interacción, para que otros servicios decidan qué hacer.
 */
@Injectable({ providedIn: "root" })
export class InactivityService {
	private readonly eventosUsuario = [
		"mousemove",
		"keydown",
		"scroll",
		"touchstart",
		"click",
	];

	private ultimaActividadMs: number = Date.now();
	private watching = false;
	private handler = this.registrarActividad.bind(this);

	constructor(private ngZone: NgZone) {}

	/** Comienza a escuchar eventos del usuario. */
	startWatching(): void {
		if (this.watching) return;
		this.watching = true;
		this.ultimaActividadMs = Date.now();

		// Se registran fuera de la zona de Angular: solo mutamos un timestamp,
		// no necesitamos disparar change detection por cada movimiento del mouse.
		this.ngZone.runOutsideAngular(() => {
			this.eventosUsuario.forEach((event) => {
				window.addEventListener(event, this.handler, { passive: true });
			});
		});
	}

	/** Alias conservado para compatibilidad con el resto del código. */
	stopWatching(): void {
		this.eliminarEventos();
	}

	eliminarEventos(): void {
		if (!this.watching) return;
		this.watching = false;
		this.eventosUsuario.forEach((event) => {
			window.removeEventListener(event, this.handler);
		});
	}

	/** Milisegundos transcurridos desde la última actividad registrada. */
	msDesdeUltimaActividad(): number {
		return Date.now() - this.ultimaActividadMs;
	}

	/** Fuerza el reseteo del contador (útil después de extender sesión). */
	resetear(): void {
		this.ultimaActividadMs = Date.now();
	}

	private registrarActividad(): void {
		this.ultimaActividadMs = Date.now();
	}
}
